/** Filtres par défaut partagés entre prefetch sidebar et page Missions (évite double GET). */
export const TEAM_MISSIONS_DEFAULT_STATUS = [
  'pending-approval',
  'awaiting-freelancer-acceptance',
  'awaiting-company-signature',
  'in-progress',
] as const

export const TEAM_MISSIONS_DEFAULT_PAGE_SIZE = 10

export const FREELANCERS_DEFAULT_STATUS = ['staffed', 'unstaffed', 'pending'] as const

export const FREELANCERS_DEFAULT_PAGE_SIZE = 8
